import React from 'react'
import { get } from 'lodash'
import { BaseDetail } from 'App/Component/Bases'
import Detail from './Detail'

const staticProps = {
  addMode: {
    showResult: false,
    showHistory: false,
    showQueues: false,
    methodSave: 'post',
    urlKeySave: 'api:admin:exim:session:list',
    isRetrieve: false,
  },
  editMode: {
    methodSave: 'put',
    urlKeySave: 'api:admin:exim:session:detail',
    isRetrieve: true,
  }
}

class ManagementExim extends BaseDetail {
  getAllowedComponent = () => {
    const isAddMode = this.props.match.params.id === 'add'
    const keyProps = isAddMode ? 'addMode' : 'editMode'
    return (
      <Detail
        {...this.props}
        {...staticProps[keyProps]}
        urlKeyDetail='api:admin:exim:session:detail'
        isAddMode={isAddMode}
        permissions={this.state.currentPermissionSet}
      />
    )
  }
}

export default ManagementExim